import { connect } from 'react-redux'
import PaginationView from '../../../components/Pagination'
import { changeListPages } from '../../../actions/meta';

const mapStateToProps = (state, ownProps) => {
  return {
  	page: state.meta.page,
    total_pages: state.meta.total_pages,
    total_results: state.meta.total_results, 
    next_page: state.meta.next_page,
    prev_page: state.meta.prev_page,
    page_lenght: state.meta.page_lenght,
    to: state.meta.to,
    fromCant: state.meta.from,
    loading: state.propiedades.loading
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
   	onClickPageNumber: value => dispatch(changeListPages(value)) 
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaginationView)


// WEBPACK FOOTER //
// ./src/containers/Sections/Propiedades/pagination.js